export default __webpack_public_path__ + "static/media/public_gists_landing.7104472e.svg";